import * as XLSX from "xlsx-color";
import * as FileSaver from "file-saver";
import { toast } from "react-toastify";
const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";
export const csvDownload = (apiData, fileName) => {
  try{  
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(apiData); 


    for (let cellAddress in worksheet) {
      if (Object.prototype.hasOwnProperty.call(worksheet, cellAddress)) {
        const cell = worksheet[cellAddress];
        if (typeof cell.v === "string") {
          cell.v = cell.v.charAt(0).toUpperCase() + cell.v.slice(1);
        }
      }
    }
   
   
    
    const columnWidths = [
      { wch: 20 }, // Width of column A is set to 15 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
      { wch: 20 }, // Width of column B is set to 20 characters
    ];

    worksheet["!cols"] = columnWidths; 
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const excelBlob = new Blob([excelBuffer], { type: fileType});
    FileSaver.saveAs(excelBlob, fileName + fileExtension);
    toast.success("CSV file Downloaded successfully")
  }catch(err){
    console.log("Error in Csv Converter:",err)
    toast.error("Something Went Wrong in CSV file Download")
  }
};
